import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/content-shape-1.svg")